import { render, staticRenderFns } from "./EditingCampaignAttr.vue?vue&type=template&id=5975412c&"
import script from "./EditingCampaignAttr.vue?vue&type=script&lang=js&"
export * from "./EditingCampaignAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports